import { AlertCircle } from "@untitledui/icons";
import type React from "react";
import ModalBase from "@/components/ui/modal/modal-base";

type ConfirmModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	onCancel?: () => void;
	title?: string;
	description?: string;
	confirmLabel?: string;
	cancelLabel?: string;
	isConfirmLoading?: boolean;
};

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	onCancel,
	title = "Confirmar ação",
	description = "Tem certeza que deseja continuar?",
	confirmLabel = "Confirmar",
	cancelLabel = "Cancelar",
	isConfirmLoading = false,
}) => {
	const handleConfirm = () => {
		onConfirm();
	};

	const handleCancel = () => {
		if (onCancel) {
			onCancel();
			return;
		}
		onClose();
	};

	return (
		<ModalBase
			actions={[
				{ label: cancelLabel, color: "secondary", onClick: handleCancel },
				{
					label: confirmLabel,
					color: "primary",
					onClick: handleConfirm,
					disabled: isConfirmLoading,
				},
			]}
			description={description}
			height="auto"
			icon={<AlertCircle />}
			iconColor="warning"
			isOpen={isOpen}
			onClose={onClose}
			title={title}
			width={400}
		/>
	);
};
